// extracted by mini-css-extract-plugin
module.exports = {"full-width":"style_full-width__1yQn1","fullWidth":"style_full-width__1yQn1","container":"style_container__2m6hO"};